import { __assign } from 'tslib';
import React from 'react';

var LoadingStatus;
(function (LoadingStatus) {
    LoadingStatus["ERROR"] = "ERROR";
    LoadingStatus["LOADED"] = "LOADED";
    LoadingStatus["PENDING"] = "PENDING";
})(LoadingStatus || (LoadingStatus = {}));
var useImgProps = function (avatarProps) {
    var _a = React.useState(LoadingStatus.PENDING), loaded = _a[0], setLoaded = _a[1];
    var imgProps = __assign(__assign({}, avatarProps.imgProps), { onLoad: function (event) {
            var _a, _b;
            setLoaded(LoadingStatus.LOADED);
            (_b = (_a = avatarProps.imgProps) === null || _a === void 0 ? void 0 : _a.onLoad) === null || _b === void 0 ? void 0 : _b.call(_a, event);
        } });
    return { imgProps: imgProps, loaded: loaded };
};

export { LoadingStatus, useImgProps };
//# sourceMappingURL=useImageProps.js.map
